/**
 * @ngdoc service
 * @name v6CoreModule.translateProvider configuration
 * @description
 * Set languages translation
 */
angular.module('v6CoreModule').config((translateProvider) => {
  // supported i18n list
  translateProvider.translations(
    'nl-nl',
    require('../../translations/nl-nl.json'),
  );
  translateProvider.translations(
    'en-gb',
    require('../../translations/en-gb.json'),
  );
  translateProvider.translations(
    'fr-fr',
    require('../../translations/fr-fr.json'),
  );
  translateProvider.translations(
    'de-de',
    require('../../translations/de-de.json'),
  );
  translateProvider.translations(
    'it-it',
    require('../../translations/it-it.json'),
  );
  translateProvider.translations(
    'es-es',
    require('../../translations/es-es.json'),
  );
});
